import { TranslationsType, useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { GTable, IGColumnProps } from '../../../../../__legacy__/components/table/GTable';
import { ITrainingResult } from '../../../jobMetrics.model';
import { IValidJobType, JOB_STATUS } from '../../../jobs.model';
import { getJobTranslationPrefix } from '../../../utils';

interface IProps {
  results: ITrainingResult[];
  status?: JOB_STATUS;
  jobType: IValidJobType;
}

type MetricKey = keyof TranslationsType['metrics']['results']['metric'];

export const ResultsTable = ({ results, jobType, status }: IProps): ReactElement => {
  const { t } = useTranslator();
  const translationPrefix = getJobTranslationPrefix(jobType);

  const gResults = (): IGColumnProps<ITrainingResult>[] => {
    if (results.length === 0) {
      return [];
    }

    const columns: IGColumnProps<ITrainingResult>[] = [
      {
        headerName: '',
        renderer(item: ITrainingResult): ReactElement {
          return <div className='results-table-name-cell'>{t(`metrics.results.metric.${item.name as MetricKey}`)}</div>;
        },
      },
    ];

    if (results[results.length - 1].train !== null) {
      columns.push({
        headerName: t('metrics.results.train'),
        renderer(item: ITrainingResult): ReactElement {
          return <div>{item.train !== null ? item.train : t('na')}</div>;
        },
      });
    }

    if (results[results.length - 1].validation !== null) {
      columns.push({
        headerName: t('metrics.results.validation'),
        renderer(item: ITrainingResult): ReactElement {
          return <div>{item.validation !== null ? item.validation : t('na')}</div>;
        },
      });
    }

    if (results[results.length - 1].test !== null) {
      columns.push({
        headerName: t('metrics.results.test'),
        renderer(item: ITrainingResult): ReactElement {
          return <div>{item.test !== null ? item.test : t('na')}</div>;
        },
      });
    }

    return columns;
  };

  if (results.length === 0) {
    return (
      <>
        <h5>{t('results')}</h5>
        <div className='no-data'>
          {status && [JOB_STATUS.FINISHED, JOB_STATUS.IMPORTED].includes(status)
            ? t(`${translationPrefix}.no_data_for_current_process`)
            : t(`${translationPrefix}.data_unavailable_during_process`)}
        </div>
      </>
    );
  }

  return (
    <>
      <h5>{t('metrics.results.title')}</h5>
      <GTable
        className={classNames('results-table')}
        columns={gResults()}
        items={results}
        isLoading={false}
        noItemsPlaceholder={''}
      />
    </>
  );
};
